import * as React from 'react'
import './Loader.scss'
import { FormattedMessage } from 'react-intl'
import { LoginType } from '../../../models/Enums'
import { Elements } from '@tfo/common'

const { Heading5, Paragraph } = Elements
const Loader = (props: {
	startingBankID?: boolean
	selectedLoginType?: LoginType
	statusText?: string
}) => {
	return (
		<div className={'Loader Loader'}>
			{props.startingBankID && (
				<>
					{props.selectedLoginType === LoginType.BankId && (
						<Heading5 className={'Loader__start-BankID'}>
							<FormattedMessage id="start.individualMobileBankID" />
							<Paragraph>{props.statusText}</Paragraph>
						</Heading5>
					)}
				</>
			)}
			<div className={'Loader__gfxHolder'}>
				<div className={'Loader__gfx'} />
				<div className={'Loader__gfx'} />
				<div className={'Loader__gfx'} />
			</div>
		</div>
	)
}

export default Loader
